module.exports = __webpack_public_path__ + "static/media/SupportTeamIcon.914857e7.svg";